module.exports = __webpack_public_path__ + "static/img/WarmPlate (19).72ddb43f.png";